export class Form{
    constructor(component) {
        this._component = component ;
        this._first_step = 'first_step';
        this._api_endpoint = null;
        this._steps = {};
    }

    apiEndpoint(value){
        this._api_endpoint = value;
        return this;
    }

    firstStep(value){
        this._first_step = value;
        return this;
    }

    addSteps(steps) {
        this._steps = {...this._steps, ...steps};
        return this;
    }

    getAllStepsKeys(){
        return _.keys(this._steps);
    }

    getStep(step){
        return this._steps[step]
    }
}
